module.exports = "<section class=\"page-about chapter\">\n  <section class=\"hero hero-bg-img\" style=\"\">\n    <div class=\"hero-inner\">\n      <div class=\"hero-content\">\n        <h1 class=\"hero-title\">Mesh Korea 정산 효율화</h1>\n      </div>\n      <p class=\"hero-tagline\">...</p>\n    </div>\n  </section>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/calculate/dashboard/dashboard.component.html
// module id = ../../../../../src/app/calculate/dashboard/dashboard.component.html
// module chunks = 3